import { isFeatureEnabled } from '@/config/featureFlags'
import { isPhase1ChatStreamConfigured } from '@/services/chatStream/postChatStream'
import { DEMO_MATCHERS_PART01 } from './demoMatcherTable.part01.js'
import { DEMO_MATCHERS_PART02 } from './demoMatcherTable.part02.js'

const DEMO_MATCHERS = [...DEMO_MATCHERS_PART01, ...DEMO_MATCHERS_PART02]

/** Canned demos never intercept real backend chat unless explicitly opted in. */
export function demoPromptsAllowed() {
  return !isPhase1ChatStreamConfigured() || isFeatureEnabled('demoPrompts')
}

/**
 * Runs the first matching canned demo stream, if any.
 *
 * @param {object} ctx stream session context passed to the demo runner
 * @param {object} q matcher inputs: { trimmed, priorMessages, files, allowResponseComponentDemo }
 * @returns {boolean} true when a demo handled the turn
 */
export function runDemoMatchedTurn(ctx, q) {
  if (!demoPromptsAllowed()) return false
  for (const matcher of DEMO_MATCHERS) {
    if (matcher.when(q)) {
      matcher.run(ctx)
      return true
    }
  }
  return false
}
